module.exports = __webpack_public_path__ + "static/media/image_not_available.72856d5c.svg";